import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { pushRecentItem } from '../utils/recentItems'

const RouteTracker = () => {
    const location = useLocation()
    useEffect(() => {
        pushRecentItem(location.pathname)
    }, [location.pathname])
    return null
}

export default RouteTracker
